(ns frontend.view.grid.surveys-grid.view
  (:require
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.react.virtualized.utils :as vu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.grid.common.components :as components]
   [frontend.view.grid.surveys-grid.common-view :as common-view]
   [frontend.view.grid.surveys-grid.db :as db]
   [frontend.view.grid.surveys-grid.download-modal.view :as download-modal]
   [frontend.view.grid.surveys-grid.events :as events]
   [frontend.view.grid.surveys-grid.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   ))



(defn view
  [{:keys [survey-type-id view-mode] :as args}]
  (let [grid-store (atom {})
        close-atom (atom false)
        resizer (fn []
                  (js/setTimeout (partial vu/recompute-grid-sizes-with-state! grid-store) 100))]
    (.addEventListener js/window "resize" resizer)
    (r/create-class
     {:component-did-mount    (fn []
                                (rf/dispatch [::events/reload survey-type-id])
                                (fu/timeout 10 (partial events/setup close-atom)))
      :component-will-unmount (fn []
                                (reset! close-atom true)
                                (events/cleanup)
                                (.removeEventListener js/window "resize" resizer))
      :reagent-render         (partial common-view/render grid-store survey-type-id)})))

(defn modals
  []
  (let [downloading? @(rf/subscribe [::sub/downloading?])]
    [download-modal/view downloading?]))

(defmethod routing/render-view :surveys-grid
  [{:keys [route-params view-params]}]
  (let [survey-type-id (-> route-params
                           :id
                           js/parseInt)
        survey-type (session/get-entity survey-type-id)]
    (let [view-mode :grid-mode]
      [default-page-layout/view
       [:<>
        [modals]
        [components/card-settings-toolbar
         [common-view/toolbar
          {:view-mode   view-mode
           :only-grid?  true
           :survey-type survey-type}] db/kanban events/close-card-settings!]
        ;;the key change forces rerendering of the component (and its child components)
        ^{:key (str "survey-profiles-" survey-type-id)}
        [view
         {:view-mode      view-mode
          :survey-type-id survey-type-id}]]])))
